module.exports = __webpack_public_path__ + "static/img/vip_task.5923241.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_task.png
// module id = 7+6S
// module chunks = 0